import { render, staticRenderFns } from "./descriptionColumn.vue?vue&type=template&id=c7c1424a"
import script from "./descriptionColumn.vue?vue&type=script&lang=js"
export * from "./descriptionColumn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports